// src/api/menuApi.js
import apiClient from "./axios";
import { menuCache } from "@/utils/menuCache";

const menuApi = {
  async getDynamicMenu(forceRefresh = false) {
    if (!forceRefresh) {
      const cachedMenu = menuCache.get();
      if (cachedMenu) {
        return Promise.resolve({ data: cachedMenu });
      }
    }

    const response = await apiClient.get("/api/menu/items");
    menuCache.set(response.data);
    return response;
  },

  getAllMenuItemsForAdmin() {
    return apiClient.get("/api/menu/admin/items");
  },

  getMenuItemById(id) {
    return apiClient.get(`/api/menu/admin/items/${id}`);
  },

  createMenuItem(data) {
    return apiClient.post("/api/menu/admin/items", data);
  },

  updateMenuItem(id, data) {
    return apiClient.put(`/api/menu/admin/items/${id}`, data);
  },

  deleteMenuItem(id) {
    return apiClient.delete(`/api/menu/admin/items/${id}`);
  },

  updateMenuRolesBatch(updates) {
    return apiClient.put("/api/menu/admin/items/roles", updates);
  },
};

export default menuApi;
